import type { FaireProductEntity } from "../../entity_types/product";

export const p_suye8v2z2s: FaireProductEntity = {
  token: "p_suye8v2z2s",
  type: "product",
  name: "Steel Ring with Oval Shaped Black Gem-A-476",
  brandToken: "b_pntx8vkece",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/37fbd398ac7c146aed6d6fa96c7c9f91dedaba3dfb54fc5d29b0297233877e92.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7d11905f2d7641f91ae52a97faebad9310c6b3827473784a13ae8f3cf189326b.jpeg",
    "https://cdn.faire.com/fastly/df4a01d2733f4d73da11d16b9efe0c29ace7dc65b2d078935803181494958bd3.jpeg",
    "https://cdn.faire.com/fastly/83ce6ca6130e78524ca3058818ecfa36d10e88120226cfdf493394bf80436342.jpeg",
  ],
  priceDollars: 15.09,
  description:
    "made of steel\nsize (size | inner diameter):\n4 > 14.9 mm\n5 > 15.7 mm\n6 > 16.5 mm\n7 > 17.3 mm\n8 > 18.1 mm\n9 > 19.0 mm\n10 > 19.8 mm\n11 > 20.6 mm\n12 > 21.4 mm\n13 > 22.2 mm\n14 > 23.0 mm",
  tags: [],
  msrpDollars: 30.18,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:31.426Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
